<template>
  <div>
    <vue-loading :type="type"  :color="color" :size="{ width: '30px', height: '30px' }"></vue-loading>
  </div>
</template>

<script>
import { VueLoading } from 'vue-loading-template'

export default {
  props:["type","color"],
  name: "ImageLoading",
  components: {
    VueLoading
  }
};
</script>

<style scoped>
.shake-image {
  animation: rotation 2s infinite ;
}

@keyframes rotation {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }}
</style>